/*
 * tcl-nav-drawer.js — the mobile drawer's subnav accordions.
 *
 * Markup: snippets/tcl-nav-drawer-sub.liquid. Styling: assets/tcl-header.css §11.
 *
 * ONE DELEGATED LISTENER ON THE DOCUMENT, not a custom element and not a
 * per-toggle binding. Two reasons, both learned in this repo:
 *
 *   - a custom element would need `customElements.define`, and a second
 *     definition of the same name THROWS. The header renders once per page today,
 *     but section-level scripts do not compose, and this file is loaded from
 *     sections/header.liquid — the guard flag below is cheaper than the class.
 *   - delegation means markup that appears after this script runs still works.
 *     The Theme Editor re-renders the header section on every setting change
 *     without re-running section scripts, so per-toggle bindings would go dead
 *     for the merchant editing the nav — the one person guaranteed to try it.
 *
 * IT DOES NOT FIGHT DAWN, IT IS EXCLUDED FROM IT. Dawn's `MenuDrawer.bindEvents`
 * (assets/global.js) binds `onCloseButtonClick` to every `button` in the drawer,
 * which closes the whole drawer. `.tl-navsub__toggle` is in that selector's
 * `:not()` exclusion list, so Dawn never binds these at all. Do NOT try to solve
 * that here with `stopImmediatePropagation`: Dawn's listener sits on the SAME
 * element and is registered first (global.js is a deferred script in the layout
 * head, this one loads with the header section), so it would already have run.
 * `tools/verify/nav-drawer-probe.mjs` asserts the exclusion is still in place.
 *
 * NO HEIGHT ANIMATION, deliberately. The panel is toggled with the `hidden`
 * attribute, which is a binary — `[hidden] { display: none }` and a transition do
 * not compose, and the max-height dance needed to animate it either hard-codes a
 * height (wrong for a 9-group list whose size is data-driven) or measures on every
 * open. The drawer itself already slides in; a second nested animation on top of
 * it is motion for its own sake.
 */
(function () {
  'use strict';

  if (window.tclNavDrawer) return;
  window.tclNavDrawer = true;

  var TOGGLE = '[data-tl-navsub-toggle]';

  document.addEventListener('click', function (event) {
    /* `event.target` can be the inline SVG inside the button, so walk up. SVG
       elements implement `closest`, so no special case is needed. */
    var toggle = event.target instanceof Element ? event.target.closest(TOGGLE) : null;
    if (!toggle) return;

    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    /* `.hidden` (the IDL attribute), not a class: it is what `aria-controls`
       promises a screen reader, and it keeps 32 links out of the tab order while
       collapsed with no CSS required to agree with it. */
    panel.hidden = isOpen;
  });
})();
